module.exports = __webpack_public_path__ + "documents/VZPH_W_Terms_and_Conditions.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/VZPH_W_Terms_and_Conditions.pdf
// module id = 3529
// module chunks = 0